import { FC, useState } from 'react';
import { PreviewImage, Stars } from 'tedooo-web-design-system/ui';
import classNames from 'classnames';

import { Avatar } from 'components/avatar/Avatar';
import { Span } from 'components/helpers';
import './reviewRow.scss';
import { IReviewRow } from 'types';
import { getShortRelativeTime, isEmptyArrayOrUndefined } from 'utils';
import { translations } from 'translations/en';
import OrderImages from 'components/OrderImages/OrderImages';

const MAX_IMAGES = 2;

const ReviewRow: FC<IReviewRow> = ({ name, date, images, value, title, text, avatar }) => {
  const formattedDate = getShortRelativeTime(date);

  const displayedDate = `${translations.COMMON.REVIEWED} ${formattedDate} ${translations.COMMON.AGO}`;

  const shouldDisplayImages = !isEmptyArrayOrUndefined(images);

  const [shouldExpand, setShouldExpand] = useState(false);

  const toggleExpansion = () => {
    setShouldExpand(!shouldExpand);
  };

  const renderedImages = () => {
    if (MAX_IMAGES < images.length) {
      const displayedImages = images.slice(0, MAX_IMAGES);

      const moreImages = images.slice(MAX_IMAGES, images.length);

      return (
        <>
          {displayedImages.map((image, index) => (
            <PreviewImage
              shouldDisplayHoverText={false}
              key={index}
              src={image}
              className="review-image"
              previewClassName="review-image-preview"
            />
          ))}
          <OrderImages images={moreImages} />
        </>
      );
    }

    return images.map((img, index) => (
      <PreviewImage
        shouldDisplayHoverText={false}
        key={index}
        src={img}
        className="review-image"
        previewClassName="review-image-preview"
      />
    ));
  };

  return (
    <div className="review-row">
      <div className="header">
        <Avatar src={avatar} size={40} />
        <div className="text-container">
          <Span text={name} className="title" />
          <Span text={displayedDate} className="text" />
        </div>
      </div>
      <Stars value={value} size="small" />
      <div className={classNames('text-container', { 'no-text': !text })}>
        {title && <Span text={title} className="title" />}
        {text && (
          <Span
            text={text}
            className={classNames('text', { expanded: shouldExpand })}
            onClick={toggleExpansion}
          />
        )}
      </div>
      {shouldDisplayImages && <div className="review-images-container">{renderedImages()}</div>}
    </div>
  );
};

export default ReviewRow;
